<template>
  <div class="form-step-3">
    <div class="section-subtitle">Персональные данные</div>
    <form ref="form" v-model="valid" class="auth-form" @change="Validate">
      <div class="avatar-block">
        <div class="auth-form--wrap add-photo">
          <div class="input-label">Аватар</div>
          <v-file-input
            v-model="file"
            accept="image/png, image/jpeg, image/webp"
            class="mt-0 pt-0"
            prepend-icon="mdi-camera-plus-outline"
            show-size
            @change="SetAvatar"
          />
          <i
            v-if="file && formData.avatar"
            class="ico-delete"
            @click="RemoveAvatar"
          >
            <svg
              fill="none"
              height="26"
              viewBox="0 0 26 26"
              width="26"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M26 13C26 20.1797 20.1797 26 13 26C5.8203 26 0 20.1797 0 13C0 5.8203 5.8203 0 13 0C20.1797 0 26 5.8203 26 13Z"
                fill="#D60000"
              />
              <path
                d="M10.6818 12.966L7.47728 9.7797C6.84091 9.01124 6.84091 8.24286 7.47728 7.47456C8.25 6.84181 9.02272 6.84181 9.79544 7.47456L13 10.7288L16.2046 7.54225C16.9773 6.9095 17.75 6.9095 18.5227 7.54225C19.1591 8.31071 19.1591 9.07909 18.5227 9.84739L15.3182 12.966L18.5227 16.1525C19.1591 16.9209 19.1591 17.6893 18.5227 18.4576C17.75 19.0904 16.9773 19.0904 16.2046 18.4576L13 15.3389L9.79544 18.5254C9.02272 19.1582 8.25 19.1582 7.47728 18.5254C6.84091 17.7571 6.84091 16.9887 7.47728 16.2203L10.6818 12.966Z"
                fill="white"
              />
            </svg>
          </i>
        </div>
        <div v-if="formData.avatar" class="avatar-img pl-5">
          <v-avatar rounded size="72">
            <img :src="formData.avatar" alt="avatar"/>
          </v-avatar>
        </div>
      </div>

      <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
        <div class="auth-form--wrap-col w50">
          <div class="input-label">Фамилия <i class="color-red">*</i></div>
          <v-text-field
            v-model="formData.last_name"
            :rules="[rules.required]"
            dense
            outlined
            required
          />
        </div>
        <div class="auth-form--wrap-col w50">
          <div class="input-label">Имя <i class="color-red">*</i></div>
          <v-text-field
            v-model="formData.first_name"
            :rules="[rules.required]"
            dense
            outlined
            required
          />
        </div>
      </div>
      <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
        <div class="auth-form--wrap-col w50">
          <div class="input-label">Отчество <i class="color-red">*</i></div>
          <v-text-field
            v-model="formData.middle_name"
            :rules="[rules.required]"
            dense
            outlined
            required
          />
        </div>
        <div class="auth-form--wrap-col w50">
          <div class="input-label">
            Дата рождения <i class="color-red">*</i>
          </div>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            min-width="auto"
            offset-y
            transition="scale-transition"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDateFormatted"
                v-bind="attrs"
                v-on="on"
                :rules="[rules.required]"
                append-icon="mdi-calendar"
                dense
                outlined
                readonly
              />
            </template>
            <v-date-picker
              v-model="formData.birthday_on_local"
              :active-picker.sync="activePicker"
              :max="
                new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
                  .toISOString()
                  .substr(0, 10)
              "
              first-day-of-week="1"
              locale="ru-ru"
              min="1950-01-01"
              @change="SaveDate"
            />
          </v-menu>
        </div>
      </div>
      <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
        <div class="auth-form--wrap-col w50">
          <div class="input-label">Размер формы <i class="color-red">*</i></div>
          <v-autocomplete
            v-model="formData.size_id"
            :clearable="true"
            :items="sizes"
            :loading="loading"
            :open-on-clear="true"
            :rules="[rules.required]"
            class="plcolor custom-autocomplete"
            dense
            height="50"
            hide-details
            hide-no-data
            item-text="name"
            item-value="id"
            required
            solo
          />
        </div>
        <div class="auth-form--wrap-col w50">
          <div class="input-label">
            Адрес для доставки подарков
          </div>
          <v-autocomplete
            v-model="formData.delivery_address"
            :clearable="true"
            :items="addresses"
            :loading="loading"
            :filter="() => true"
            :open-on-clear="true"
            :rules="[rules.required]"
            :search-input.sync="searchAddress"
            class="plcolor custom-autocomplete"
            dense
            height="50"
            hide-details
            hide-no-data
            item-text="unrestricted_value"
            item-value="unrestricted_value"
            required
            solo
          />
        </div>
      </div>

      <div class="auth-form--wrap">
        <div class="input-label">
          Адрес электронный почты <i class="color-red">*</i>
        </div>
        <v-text-field
          v-model="formData.email"
          :rules="[rules.required, rules.email]"
          dense
          outlined
          required
        />
      </div>

      <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
        <div id="password" class="auth-form--wrap-col w50 password-field">
          <div class="input-label">Пароль <i class="color-red">*</i></div>
          <v-text-field
            v-model="formData.password"
            :append-icon="!hidePw ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[rules.required]"
            :type="hidePw ? 'password' : 'text'"
            autocomplete="new-password"
            counter
            dense
            outlined
            required
            @click:append="hidePw = !hidePw"
          />
        </div>
        <div class="auth-form--wrap-col w50">
          <div class="input-label">
            Подтверждение пароля <i class="color-red">*</i>
          </div>
          <v-text-field
            v-model="formData.passwordConfirm"
            :append-icon="!hidePw ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="[comparePasswords]"
            :type="hidePw ? 'password' : 'text'"
            autocomplete="new-password"
            counter
            dense
            outlined
            required
            @change="Validate"
            @click:append="hidePw = !hidePw"
          />
        </div>
      </div>

      <div class="auth-form--wrap mb-5">
        <div class="input-label">Город <i class="color-red">*</i></div>
        <v-autocomplete
          v-model="formData.city_id"
          :clearable="true"
          :items="cities"
          :loading="loading"
          :open-on-clear="true"
          :rules="[rules.required]"
          :search-input.sync="searchCity"
          class="plcolor custom-autocomplete"
          dense
          hide-details
          hide-no-data
          item-text="title"
          item-value="id"
          required
          solo
        />
      </div>
      <div class="auth-form--wrap d-flex flex-wrap justify-space-between">
        <div class="auth-form--wrap-col w50">
          <div class="input-label">Ссылка на соц сеть №1</div>
          <v-text-field v-model="formData.socialLink1" dense outlined/>
        </div>
        <div class="auth-form--wrap-col w50">
          <div class="input-label">Ссылка на соц сеть №2</div>
          <v-text-field v-model="formData.socialLink2" dense outlined/>
        </div>
      </div>

      <v-btn
        :disabled="!valid"
        class="w-100 btn-blue"
        color="primary"
        @click="Submit"
      >Продолжить
      </v-btn>
    </form>
  </div>
</template>

<script>
const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const patternPassword = (val) => {
  const isEmpty = !val;
  const lessThen8Symbols = val.length < 8;
  const noDigits = !/\d/.test(val);
  const hasSpaces = /\s/.test(val);
  const noCapitalLetter = !/[A-Z]/.test(val);
  const noLowercaseLetter = !/[a-z]/.test(val);
  const noSpecialCharacter = !/(?=.*[!@#$%^&*])/.test(val);
  return {
    isEmpty,
    lessThen8Symbols,
    noDigits,
    hasSpaces,
    noCapitalLetter,
    noLowercaseLetter,
    noSpecialCharacter,
  };
};

export default {
  name: 'FormStep3',
  props: ['form'],
  data() {
    return {
      activePicker: null,
      menu: false,
      file: null,
      sizes: [],
      cities: [],
      searchCity: '',
      valid: false,
      hidePw: true,
      searchAddress: '',
      addresses: [],
      rules: {
        required: v => !!v || 'Поле должно быть заполнено',
        email: v => pattern.test(v) || 'Поле E-mail заполнено с ошибками',
        passwordValid: (v) => {
          const passwordCheck = patternPassword(v);
          let valid = true;
          Object.keys(passwordCheck).forEach((key) => {
            if (passwordCheck[key]) {
              valid = false;
            }
          });
          return valid;
        },
      },
      formData: {
        first_name: '',
        last_name: '',
        middle_name: '',
        email: '',
        password: '',
        passwordConfirm: '',
        socialLink1: '',
        socialLink2: '',
        birthday_on_local: null,
        city_id: null,
        avatar: null,
        size_id: null,
        delivery_address: null,
      },
    };
  },
  mounted() {
    this.$store.getters.axl
      .post('/shop/api-v3/size/list')
      .then((result) => {
        this.sizes = result.data.sizes;
      });
  },
  computed: {
    computedDateFormatted() {
      return this.FormatDate(this.formData.birthday_on_local);
    },
    loading() {
      return this.$store.state.loading;
    },
  },
  watch: {
    'formData.password': (value) => {
      const passwordField = document.getElementById('password');
      const messageWrapper = passwordField.getElementsByClassName(
        'v-messages__wrapper',
      )[0];
      messageWrapper.innerHtml = '';
      messageWrapper.innerText = '';
      const checkPassword = patternPassword(value);
      const resultObject = {
        lessThen8Symbols: 'минимум 8 символов',
        noDigits: '1 цифра',
        noCapitalLetter: '1 заглавная латинская буква',
        noLowercaseLetter: '1 прописная латинская буква',
        noSpecialCharacter: '1 специальный символ',
        hasSpaces: 'без пробелов',
      };
      const div = document.createElement('div');
      const beginning = document.createElement('span');
      if (checkPassword.isEmpty) {
        return;
      }
      div.appendChild(beginning);
      Object.keys(resultObject).forEach((key) => {
        const messageDiv = document.createElement('div');
        const color = checkPassword[key] ? 'red' : 'green';
        const icon = document.createElement('i');
        icon.style.color = color;
        icon.innerHTML = checkPassword[key] ? '✗' : '✓';
        messageDiv.appendChild(icon);
        const message = document.createElement('span');
        message.innerHTML = resultObject[key];
        message.style.color = color;
        message.style.marginLeft = '5px';
        messageDiv.appendChild(message);
        div.appendChild(messageDiv);
      });
      messageWrapper.appendChild(div);
    },
    /** Вотчер для даты */
    menu(val) {
      // eslint-disable-next-line no-return-assign
      val && setTimeout(() => (this.activePicker = 'YEAR'));
    },
    /** Вотчер для автокомплита городов */
    searchCity(val) {
      if (!val) {
        this.cities = [];
        return;
      }
      this.$store.getters.axl
        .post('location/api/cities/list', { term: val })
        .then((result) => {
          this.cities = result.data.cities;
        });
    },
    searchAddress(val) {
      if (!val) {
        this.addresses = [];
        return;
      }
      this.$store.getters.axl.post('profiles/api/profiles/autocomplete-address', { term: val })
        .then((result) => {
          this.addresses = result.data.addresses;
        });
    },
  },
  methods: {
    comparePasswords() {
      return this.formData.password === this.formData.passwordConfirm
        ? true
        : 'Пароли не совпадают';
    },
    /** Записать дату */
    SaveDate(date) {
      this.$refs.menu.save(date);
    },
    /** Форматировать дату для формы */
    FormatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split('-');
      return `${day}.${month}.${year}`;
    },
    /** Сохранить аватар */
    SetAvatar(e) {
      const app = this;
      const fr = new FileReader();
      fr.readAsDataURL(e);
      fr.addEventListener('load', () => {
        app.formData.avatar = fr.result;
      });
    },
    /** Удалить аватар */
    RemoveAvatar() {
      this.formData.avatar = '';
      this.file = null;
    },
    /** Привести дату к формату для бэка */
    ParseDate(date) {
      if (!date) return null;

      return date;
      // const [month, day, year] = date.split('/');
      // return `${day.padStart(2, '0')}-${month.padStart(2, '0')}-${year}`;
    },
    /** Валидация формы */
    Validate() {
      this.valid = this.$refs.form.reportValidity()
        && this.rules.email(this.formData.email) === true
        && this.rules.passwordValid(this.formData.password) === true
        && this.comparePasswords() === true;
    },
    /** Переход к следующему шагу */
    Submit() {
      const data = {
        ...this.formData,
        birthday_on_local: this.FormatDate(this.formData.birthday_on_local),
      };
      this.$emit('submit', data);
    },
  },
};
</script>
